<template>
    <MenuVue :activeId="activeId" @changeActiveId="changeActiveId" />
    <div class="index-page">
        <div class="main-container">
            <div class="kc-container">
                <div class="kc-wrap">
                    <div class="kc-ul">
                        <div class="kc-li-list">
                            <div class="kc-li" v-for="(item, idx) in courseList.list" :key="idx">
                                <img class="img" :src="item.img_url" @click="playVideo(item)" />
                                <div class="info-wrap">
                                    <div class="title nowrap ellipsis">{{ item.title }}</div>
                                    <div class="user-num">{{ item.user_count }} 学员</div>
                                    <div class="price-wrap">
                                        <div class="price">￥{{ item.price }}</div>
                                        <div class="right-btns">
                                            <div @click="playVideo(item)" class="abtn btn-play">播放</div>
                                            <div @click="exchangeCourse(item)" class="abtn btn-exchange" v-if="item.is_buy == 0">兑换</div>
                                            <div @click="buyCourse(item)" class="abtn btn-buy" v-if="item.is_buy == 0">购买</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="page-wrap" v-if="pageList.length >= 2">
                        <div class="pagebar">
                            <div class="pitem prev" @click="toPrevPage"></div>
                            <div class="pitem" v-for="(item, idx) in pageList" :key="idx" :class="{ active: item.active }" @click="toPage(item.num)">{{ item.num }}</div>
                            <div class="pitem next" @click="toNextPage"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <FooterVue />
    <DialogQrcodeVue v-if="visibleQrcode" @close="dialogQrcodeClose" />
    <AIRigisterResult v-if="aiRegister.visible"  :data="aiRegister.data" @close="onHideRegisterResult" />
</template>

<script>
import MenuVue from '../components/Menu.vue'
import FooterVue from '../components/Footer.vue'
import DialogQrcodeVue from '@/components/DialogQrcode.vue'
import ExchangeDialogVue from '@/components/ExchangeDialog.vue'
import AIRigisterResult from '@/components/AIRigisterResult.vue'

import { get, post } from '../utils/request'
export default {
    components: { MenuVue, FooterVue, DialogQrcodeVue, ExchangeDialogVue ,AIRigisterResult},
    data() {
        return {
            activeId: 0,
            visibleQrcode: false,
            aiRegister:{
                visible:false,
                data:null,
            },
            exchangeDialog: {
                visible: false,
                courseId: 0
            },
            bannerList: [],
            courseList: {
                list: [],
                total: 1
            },
            pageList: [],
            query: {
                page: 1,
                limit: 8
            }
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo
        },
        categoryList() {
            return this.$store.state.categoryList
        },
        env() {
            return this.$store.state.env
        }
    },
    created() {
        this.activeId = this.$route.query.id
        this.loadCourseList()
    },
    mounted() {},
    methods: {
        async loadCourseList() {
            var res = await get('/course/list', {
                category: this.activeId
            })
            console.log(res)
            this.courseList.list = res.data.list
            this.courseList.total = res.data.lastPage
            this.calcPageList()
        },
        calcPageList() {
            // 分页
            var startPage = this.query.page - 2
            if (startPage < 1) startPage = 1
            var endPage = startPage + 4
            if (endPage > this.courseList.total) {
                endPage = this.courseList.total
            }
            this.pageList = []
            for (var i = startPage; i <= endPage; i++) {
                this.pageList.push({
                    num: i,
                    active: this.query.page == i ? 1 : 0
                })
            }
        },
        dialogQrcodeClose() {
            this.visibleQrcode = false
        },
        exchangeDialogClose() {
            this.exchangeDialog.visible = false
        },
        toDetail(item, idx) {
            this.$router.push('/detail?id=' + 1)
        },
        playVideo(item) {
            if (item.is_buy) {
                this.$router.push('/detail?id=' + item.id)
                // this.$router.push('/jump?spu_id='+ item.spu_id); 
            } else {
                this.$router.push('/detail?id=' + item.id)
            }
        },
        exchangeCourse(item) {
            if (this.userInfo == null) {
                window.location.href = '/login?back=%2Fai-course'
            } else {
                this.exchangeDialog.visible = true
                this.exchangeDialog.courseId = item.id
            }
        },
        buyCourse(item) {
            this.visibleQrcode = true
        },
        toPrevPage() {
            this.query.page--
            if (this.query.page < 1) this.query.page = 1
            this.loadCourseList()
        },
        toNextPage() {
            this.query.page++
            if (this.query.page > this.courseList.total) this.query.page = this.courseList.total
            this.loadCourseList()
        },
        toPage(num) {
            this.query.page = num
            this.loadCourseList()
        },
        toBannerUrl(item) {
            if (item.url && item.url.length > 0) {
                window.open(item.url)
            }
        },
        onExchangeSuccess(data) {
            if(data){
                this.aiRegister.data = data;
                this.aiRegister.visible = true;
            }
            this.loadCourseList()
        },
        changeActiveId(id) {
            this.activeId = id
            this.query.page = 1
            this.loadCourseList()
        },
        onHideRegisterResult() {
            this.aiRegister.visible = false
        }
    }
}
</script>
<style scoped lang="scss">
$s1024: 0.5333;
$s750: 1;
.index-page {
    line-height: 1.5;
    .main-container {
        .kc-container {
            background: #eef0f2;
            .kc-wrap {
                padding: 1.3rem 0 0.7rem 0;
                width: 15.95rem;
                margin: 0 auto;
                text-align: center;
                @media screen and (max-width: 1024px) {
                    padding: (1.8rem * $s1024) 0;
                    width: (15.95rem * $s1024);
                }
                @media screen and (max-width: 750px) {
                    padding: (1.3rem * $s750) 0;
                    width: 100%;
                }
                .kc-head {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    font-size: 0.48rem;
                    color: #000000;
                    background: url(../assets/title_bg.png) no-repeat center center;
                    background-size: 2.86rem 0.29rem;
                    font-weight: bold;
                    margin-bottom: 0.2rem;
                    @media screen and (max-width: 1024px) {
                        font-size: (0.48rem * $s1024);
                        background-size: (2.86rem * $s1024) (0.29rem * $s1024);
                        margin-bottom: (0.2rem * $s1024);
                    }
                    @media screen and (max-width: 750px) {
                        font-size: (0.38rem * $s750);
                        background-size: (2.86rem * $s750) (0.29rem * $s750);
                        margin-bottom: (0.2rem * $s750);
                    }
                }
                .kc-sub-head {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    font-size: 0.28rem;
                    color: #6b7280;
                    margin-bottom: 0.7rem;
                    @media screen and (max-width: 1024px) {
                        font-size: (0.28rem * $s1024);
                        margin-bottom: (0.7rem * $s1024);
                    }
                    @media screen and (max-width: 750px) {
                        font-size: (0.22rem * $s750);
                        margin-bottom: (0.7rem * $s750);
                    }
                }
                .kc-ul {
                    overflow-x: hidden;
                    .kc-li-list {
                        margin-left: -0.15rem;
                        margin-right: -0.15rem;
                        display: flex;
                        flex-direction: row;
                        justify-content: flex-start;
                        flex-wrap: wrap;
                        @media screen and (max-width: 1024px) {
                            margin-left: (-0.15rem * $s1024);
                            margin-right: (-0.15rem * $s1024);
                        }
                        @media screen and (max-width: 750px) {
                            margin-left: (0.1rem * $s750);
                            margin-right: (-0.15rem * $s750);
                        }
                        .kc-li {
                            width: 3.7rem;
                            height: 4.2rem;
                            background: #fff;
                            border-radius: 0.2rem;
                            box-shadow: 0 0 0.1rem rgba(0, 0, 0, 0.2);
                            margin: 0 0.15rem 0.55rem 0.15rem;
                            @media screen and (max-width: 1024px) {
                                width: (3.7rem * $s1024);
                                height: (4.2rem * $s1024);
                                border-radius: (0.2rem * $s1024);
                                margin: 0 (0.15rem * $s1024) (0.55rem * $s1024) (0.15rem * $s1024);
                            }
                            @media screen and (max-width: 750px) {
                                width: (3.34rem * $s750);
                                height: (4rem * $s750);
                                border-radius: (0.2rem * $s750);
                                margin: 0 (0.15rem * $s750) (0.55rem * $s750) (0.15rem * $s750);
                            }
                            .img {
                                width: 100%;
                                height: 2.4rem;
                                object-fit: cover;
                                border-top-left-radius: 0.2rem;
                                border-top-right-radius: 0.2rem;
                                display: block;
                                @media screen and (max-width: 1024px) {
                                    height: (2.4rem * $s1024);
                                    border-top-left-radius: (0.2rem * $s1024);
                                    border-top-right-radius: (0.2rem * $s1024);
                                }
                                @media screen and (max-width: 750px) {
                                    height: (2.4rem * $s750);
                                    border-top-left-radius: (0.2rem * $s750);
                                    border-top-right-radius: (0.2rem * $s750);
                                }
                            }
                            .info-wrap {
                                padding: 0.24rem 0.16rem;
                                display: flex;
                                flex-direction: column;
                                align-content: flex-start;
                                align-items: flex-start;
                                @media screen and (max-width: 1024px) {
                                    padding: (0.24rem * $s1024) (0.16rem * $s1024);
                                }
                                @media screen and (max-width: 750px) {
                                    padding: (0.24rem * $s750) (0.16rem * $s750);
                                }
                                .title {
                                    width: 100%;
                                    text-align: left;
                                    font-size: 0.2rem;
                                    font-weight: bold;
                                    color: #0c1721;
                                    margin-bottom: 0.1rem;
                                    @media screen and (max-width: 1024px) {
                                        font-size: (0.2rem * $s1024);
                                        margin-bottom: (0.1rem * $s1024);
                                    }
                                    @media screen and (max-width: 750px) {
                                        font-size: (0.2rem * $s750);
                                        margin-bottom: (0.1rem * $s750);
                                    }
                                }
                                .user-num {
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: flex-start;
                                    align-content: center;
                                    align-items: center;
                                    font-size: 0.14rem;
                                    color: #6f6e71;
                                    @media screen and (max-width: 1024px) {
                                        font-size: (0.14rem * $s1024);
                                    }
                                    @media screen and (max-width: 750px) {
                                        font-size: (0.14rem * $s750);
                                    }
                                    &::before {
                                        content: ' ';
                                        display: block;
                                        width: 0.15rem;
                                        height: 0.13rem;
                                        background: url(../assets/icon_user.png) no-repeat center center;
                                        background-size: contain;
                                        margin-right: 0.08rem;
                                        @media screen and (max-width: 1024px) {
                                            width: (0.15rem * $s1024);
                                            height: (0.13rem * $s1024);
                                            margin-right: (0.08rem * $s1024);
                                        }
                                        @media screen and (max-width: 750px) {
                                            width: (0.15rem * $s750);
                                            height: (0.13rem * $s750);
                                            margin-right: (0.08rem * $s750);
                                        }
                                    }
                                }
                                .price-wrap {
                                    width: 100%;
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                    align-content: center;
                                    align-items: center;
                                    margin-top: 0.34rem;
                                    @media screen and (max-width: 1024px) {
                                        margin-top: (0.34rem * $s1024);
                                    }
                                    @media screen and (max-width: 750px) {
                                        margin-top: (0.14rem * $s750);
                                    }
                                    .price {
                                        font-size: 0.3rem;
                                        color: #eb2234;
                                        font-weight: bold;
                                        @media screen and (max-width: 1024px) {
                                            font-size: (0.3rem * $s1024);
                                        }
                                        @media screen and (max-width: 750px) {
                                            font-size: (0.3rem * $s750);
                                        }
                                    }
                                    .right-btns {
                                        display: flex;
                                        flex-direction: row;

                                        .abtn {
                                            width: 0.51rem;
                                            height: 0.31rem;
                                            font-size: 0.14rem;
                                            justify-content: center;
                                            align-content: center;
                                            align-items: center;
                                            display: flex;
                                            margin-left: 0.1rem;
                                            border-radius: 0.04rem;
                                            cursor: pointer;
                                            line-height: 0.31rem;
                                            @media screen and (max-width: 1024px) {
                                                width: (0.51rem * $s1024);
                                                height: (0.31rem * $s1024);
                                                font-size: (0.14rem * $s1024);
                                                margin-left: (0.1rem * $s1024);
                                                border-radius: (0.04rem * $s1024);
                                                line-height: (0.31rem * $s1024);
                                            }
                                            @media screen and (max-width: 750px) {
                                                width: (0.51rem * $s750);
                                                height: (0.31rem * $s750);
                                                font-size: (0.14rem * $s750);
                                                margin-left: (0.1rem * $s750);
                                                border-radius: (0.04rem * $s750);
                                                line-height: (0.31rem * $s750);
                                            }
                                            &.btn-play {
                                                border: 1px solid rgba(0, 0, 0, 0.5);
                                                color: #666463;
                                            }
                                            &.btn-exchange {
                                                border: 1px solid #eb2234;
                                                color: #eb2234;
                                            }
                                            &.btn-buy {
                                                border: 1px solid #eb2234;
                                                color: #fff;
                                                background: #eb2234;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                .page-wrap {
                    padding: 0.16rem 0;
                    @media screen and (max-width: 1024px) {
                        padding: (0.16rem * $s1024) 0;
                    }
                    @media screen and (max-width: 750px) {
                        padding: (0.16rem * $s750) 0;
                    }
                    .pagebar {
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-content: center;
                        align-items: center;
                        .pitem {
                            width: 0.26rem;
                            height: 0.26rem;
                            margin: 0 0.1rem;
                            font-size: 0.2rem;
                            color: #0c1721;
                            cursor: pointer;
                            @media screen and (max-width: 1024px) {
                                width: (0.26rem * $s1024);
                                height: (0.26rem * $s1024);
                                margin: 0 (0.1rem * $s1024);
                                font-size: (0.2rem * $s1024);
                            }
                            @media screen and (max-width: 750px) {
                                width: (0.32rem * $s750);
                                height: (0.32rem * $s750);
                                margin: 0 (0.1rem * $s750);
                                font-size: (0.26rem * $s750);
                                line-height: (0.32rem * $s750);
                            }
                            &.active {
                                color: #eb2234;
                            }
                            &.prev {
                                background: url(../assets/icon_prev.png) no-repeat center center;
                                background-size: 0.12rem 0.19rem;
                                @media screen and (max-width: 1024px) {
                                    background-size: (0.12rem * $s1024) (0.19rem * $s1024);
                                }
                                @media screen and (max-width: 750px) {
                                    background-size: (0.12rem * $s750) (0.19rem * $s750);
                                }
                            }
                            &.next {
                                background: url(../assets/icon_next.png) no-repeat center center;
                                background-size: 0.12rem 0.19rem;
                                @media screen and (max-width: 1024px) {
                                    background-size: (0.12rem * $s1024) (0.19rem * $s1024);
                                }
                                @media screen and (max-width: 750px) {
                                    background-size: (0.12rem * $s750) (0.19rem * $s750);
                                }
                            }
                        }
                    }
                }
            }
        }
        .about-container {
            background: #f7f9fb;
            padding: 1.1rem 0;
            @media screen and (max-width: 1024px) {
                padding: (1.1rem * $s1024) 0;
            }
            @media screen and (max-width: 750px) {
                padding: (0.5rem * $s750) 0;
            }
            .about-wrap {
                width: 8.1rem;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                margin: 0 auto;
                @media screen and (max-width: 1024px) {
                    width: (8.1rem * $s1024);
                }
                @media screen and (max-width: 750px) {
                    width: 100%;
                    flex-direction: column;
                    justify-content: center;
                    align-content: center;
                    align-items: center;
                    text-align: center;
                }
                .qrcode {
                    width: 1.8rem;
                    height: 1.8rem;
                    border-radius: 0.2rem;
                    background-color: #eef0f2;
                    @media screen and (max-width: 1024px) {
                        width: (1.8rem * $s1024);
                        height: (1.8rem * $s1024);
                        border-radius: (0.2rem * $s1024);
                    }
                    @media screen and (max-width: 750px) {
                        display: none;
                    }
                }
                .right-wrap {
                    width: 5.8rem;
                    @media screen and (max-width: 1024px) {
                        width: (5.8rem * $s1024);
                    }
                    @media screen and (max-width: 750px) {
                        width: 100%;
                    }
                    .title {
                        font-size: 0.48rem;
                        line-height: 1;
                        font-weight: bold;
                        color: #000000;
                        margin-bottom: 0.2rem;
                        @media screen and (max-width: 1024px) {
                            font-size: (0.48rem * $s1024);
                            margin-bottom: (0.2rem * $s1024);
                        }
                        @media screen and (max-width: 750px) {
                            font-size: (0.38rem * $s750);
                            margin-bottom: (0.2rem * $s750);
                        }
                    }
                    .sub-title {
                        font-size: 0.22rem;
                        color: #000000;
                        margin-bottom: 0.2rem;
                        @media screen and (max-width: 1024px) {
                            font-size: (0.22rem * $s1024);
                            margin-bottom: (0.2rem * $s1024);
                        }
                        @media screen and (max-width: 750px) {
                            font-size: (0.22rem * $s750);
                            margin-bottom: (0.2rem * $s750);
                            color: rgba(0, 0, 0, 0.8);
                        }
                    }
                    .btn-qrcode {
                        width: 1.8rem;
                        height: 0.6rem;
                        border-radius: 999px;
                        border: 1px solid #eb2234;
                        color: #eb2234;
                        font-size: 0.26rem;
                        text-align: center;
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-content: center;
                        align-items: center;
                        cursor: pointer;
                        @media screen and (max-width: 1024px) {
                            width: (1.8rem * $s1024);
                            height: (0.6rem * $s1024);
                            font-size: (0.26rem * $s1024);
                        }
                        @media screen and (max-width: 750px) {
                            display: none;
                        }
                    }
                }
                .mqrcode {
                    width: (2rem * $s750);
                    height: (2rem * $s750);
                    border-radius: (0.2rem * $s750);
                    background-color: #eef0f2;
                    margin: 0.3rem 0 0.15rem 0;
                    display: none;
                    @media screen and (max-width: 750px) {
                        display: block;
                    }
                }
                .mqrcode-text {
                    font-size: (0.21rem * $s750);
                    color: rgba(0, 0, 0, 0.8);
                    display: none;
                    @media screen and (max-width: 750px) {
                        display: block;
                    }
                }
            }
        }
    }
}
</style>

<style lang="scss">
$s1024: 0.5333;
$s750: 1;
.mypagination {
    height: 0.2rem !important;
    bottom: 0.2rem !important;
    overflow: hidden;
    @media screen and (max-width: 1024px) {
        height: (0.2rem * $s1024) !important;
        bottom: (0.2rem * $s1024) !important;
    }
    @media screen and (max-width: 750px) {
        height: (0.2rem * $s750) !important;
        bottom: (0.2rem * $s750) !important;
    }
    .swiper-pagination-bullet {
        width: 0.16rem !important;
        height: 0.16rem !important;
        border-radius: 999px !important;
        background: #fff;
        opacity: 1;
        @media screen and (max-width: 1024px) {
            width: (0.16rem * $s1024) !important;
            height: (0.16rem * $s1024) !important;
        }
        @media screen and (max-width: 750px) {
            width: (0.16rem * $s750) !important;
            height: (0.16rem * $s750) !important;
        }
        &.swiper-pagination-bullet-active {
            width: 0.3rem !important;
            background-color: #eb2234 !important;
            @media screen and (max-width: 1024px) {
                width: (0.3rem * $s1024) !important;
            }
            @media screen and (max-width: 750px) {
                width: (0.3rem * $s750) !important;
            }
        }
    }
}
</style>
